import { useCallback } from 'react';

import { useMutation } from '@apollo/client';

import {
  DeleteChallengePhaseDocument,
  DeleteChallengePhaseMutationVariables,
} from './Tournament.mutation.generated';

export const useDeleteChallengePhaseOne = () => {
  const [runMutation, status] = useMutation(DeleteChallengePhaseDocument, {
    context: { role: 'club' },
  });

  const execute = useCallback(
    (variables: DeleteChallengePhaseMutationVariables) => {
      return runMutation({
        variables,
        update: (cache) => {
          cache.evict({ id: `tournaments_challenge_rule:${variables.ruleId}` });
        },
      });
    },
    [runMutation]
  );

  return { execute, status };
};
